import 'UI/Widget/Forms/Control/Element'

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Element
 */
UI.Widget.Forms.Control.Input = Class(UI.Widget.Forms.Control.Element, /** @lends UI.Widget.Forms.Control.Input.prototype */ {
    bind: function() {
        this.ParentCall();

        this.listenElement();
    },

    createElement: function() {
        this.$element = $("<input>");

        if (this.disabled) {
            this.$element.prop("disabled", true);
        }
    },

    updateElement: function(value) {
        this.$element.val(Util.isDefined(value) ? value : null);
    },

    listenElement: function() {
        var self = this;

        if (!this.disabled) {
            this.$element.on("change", function() {
                self.setValue(this.value);
            });
        }
    },

    editMode () {
        this.ParentCall()
        this.$input && this.$input.prop('disabled', false)
    },
    viewMode () {
        this.ParentCall()
        this.$input && this.$input.prop('disabled', true)
    },
});
